module.exports = __webpack_public_path__ + "img/love-up.6ec08e48.png";